import React from 'react';
import CardKeyValue from '../../../../../card/cardKeyValue';
import FormatDate from '../../../../../date/FormatDate';

const BasicInformation = ({ detail }) => (
  <div className='flex flex-wrap gap-4 pb-2 items-strech justify-center overflow-auto'>
    {detail?.name && (
      <CardKeyValue className='min-w-100px max-w-500px' title='Survey Name' value={detail.name || ''} />
    )}

    {detail?.dueDate && (
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Due Date'
        value={detail.dueDate ? <FormatDate date={detail.dueDate} /> : ''}
      />
    )}

    {detail?.template && (
      <CardKeyValue
        className='min-w-100px max-w-500px'
        title='Template'
        value={detail.template?.title || ''}
      />
    )}

    {detail?.notes && (
      <CardKeyValue className='min-w-100px max-w-500px' title='Notes' value={detai?.notes || ''} />
    )}
  </div>
);

export default BasicInformation;
